import { useEffect, useState } from 'react';
import {
  Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress,
} from '@mui/material';

import { InputField, ButtonDelete, ButtonSend, SelectField } from '../../../../../components';

import { WHATSAPP_URL } from '../../../../../config/constants';

const EditGroup = () => {
  const [selectedGroup, setSelectedGroup] = useState();
  const [groupEdited, setGroupEdited] = useState(selectedGroup);
  const [call, setCall] = useState(false);
  const [whatsappGroups, setWhatsappGroups] = useState([]);
  const [loadingGroups, setLoadingGroups] = useState(false);

  const getSelectedGroup = async (data) => setSelectedGroup(data);

  useEffect(() => setGroupEdited(selectedGroup), [selectedGroup]);

  useEffect(() => {
    const id = selectedGroup?.id;

    if (!id) {
      setWhatsappGroups([]);
      return;
    }

    let active = true;

    (async () => {
      setLoadingGroups(true);

      try {
        const response = await fetch(`${WHATSAPP_URL}/sendGroup/whatsappGroups/${id}`, {
          method: 'GET',
          credentials: 'include',
        });

        const { message } = await response.json();

        if (active) setWhatsappGroups(Array.isArray(message) ? message : []);
      } catch {
        if (active) setWhatsappGroups([]);
      } finally {
        if (active) setLoadingGroups(false);
      }
    })();

    return () => { active = false; };
  }, [selectedGroup?.id]);

  const verifyFields = (form) => {
    const data = new FormData(form);

    setCall(!call);

    setGroupEdited(data.get('group'));

    for (const [, value] of data.entries()) if (value === '') return;

    return true;

  };

  const handleSubmit = async () => {

    const groupData = {
      group: groupEdited.trim(),
      selectedGroup: selectedGroup.id
    };

    for (let key in groupData) if (!groupData[key]) return false;

    const options = {
      method: 'PATCH',
      body: JSON.stringify(groupData),
      headers: {
        'Content-type': 'application/json'
      },
      credentials: 'include'
    };

    const response = await fetch(`${WHATSAPP_URL}/sendGroup/update`, options);

    const { error } = await response.json();

    if (response.status !== 200) return error;

  };

  const handleDelete = async () => {

    const options = {
      method: 'DELETE',
      credentials: 'include',
    };

    const response = await fetch(`${WHATSAPP_URL}/sendGroup/delete/${selectedGroup.id}`, options);

    if (response.status === 204) return;
    else return 'Falha ao deletar o grupo';

  };

  return (
    <Box component='main' style={styles.container}>

      <fieldset style={styles.fieldset}>
        <legend style={styles.title}>Editar Grupo de Envio</legend>

        <Box component='form' style={styles.contentBox} >

          <Box style={styles.divisor}>

            <InputField
              label='Nome do Grupo de Envio'
              name='group'
              type='group'
              defaultValue={groupEdited?.name}
            />

          </Box>

          <SelectField
            getSelectedValue={getSelectedGroup}
            nameVariable='send_group'
            URL={`${WHATSAPP_URL}/sendGroup/getAll`}
            isEmpty={true}
            label='Grupo'
          />

          <Box style={styles.buttonBox}>

            <ButtonDelete
              text='Deletar Grupo de Envio'
              handleDelete={handleDelete}
              description='Tem certeza de que deseja deletar este grupo?'
              descriptionSuccess='Grupo deletado com sucesso!'
            />

            <ButtonSend
              verifyFields={verifyFields}
              value={groupEdited}
              handleSubmit={handleSubmit}
              text='Editar Grupo de Envio'
              description={`Tem certeza de que deseja editar o grupo ${selectedGroup?.name}?`}
              descriptionSuccess={`O grupo ${selectedGroup?.name} foi atualizado com sucesso para ${groupEdited}!`}
            />

          </Box>
        </Box>
      </fieldset>

      {selectedGroup?.id && (
        <Box style={styles.tableWrapper}>
          <Typography style={styles.tableTitle}>
            Grupos de Whatsapp {selectedGroup?.name ? `— ${selectedGroup.name}` : ''}
            {!loadingGroups && ` (${whatsappGroups.length})`}
          </Typography>

          {loadingGroups ? (
            <Box style={styles.tableLoading}><CircularProgress size={28} /></Box>
          ) : whatsappGroups.length === 0 ? (
            <Typography style={styles.tableEmpty}>Nenhum grupo de Whatsapp vinculado a este grupo de envio.</Typography>
          ) : (
            <TableContainer component={Paper} style={styles.tableContainer}>
              <Table size='small' aria-label='grupos de whatsapp'>
                <TableHead>
                  <TableRow>
                    <TableCell style={styles.headCell}>#</TableCell>
                    <TableCell style={styles.headCell}>Nome do Grupo de Whatsapp</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {whatsappGroups.map((name, index) => (
                    <TableRow key={`${name}-${index}`}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{name}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      )}
    </Box>
  );
};

const styles = {
  container: {
    width: '50%',
    marginTop: '2em'
  },

  fieldset: {
    borderRadius: '15px',
    border: 'solid',
    borderWidth: '3px',
    borderColor: '#202956',
    height: 'fit-content',
  },

  title: {
    color: '#202956',
    fontSize: '30px',
    margin: '0 auto',
    fontWeight: '500',
    padding: '0 10px'
  },

  contentBox: {
    padding: '6% 4% 4% 4%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%'
  },

  divisor: {
    marginBottom: '15px',
  },

  buttonBox: {
    padding: '4% 4% 0 4%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    margin: '0 auto',
  },

  tableWrapper: {
    marginTop: '1.5em',
  },

  tableTitle: {
    color: '#202956',
    fontSize: '18px',
    fontWeight: '500',
    marginBottom: '0.5em',
  },

  tableContainer: {
    maxHeight: '20em',
    overflowY: 'auto',
  },

  headCell: {
    fontWeight: '600',
    color: '#202956',
  },

  tableLoading: {
    display: 'flex',
    justifyContent: 'center',
    padding: '1em',
  },

  tableEmpty: {
    color: '#5a5a5a',
    fontStyle: 'italic',
  },

};

export default EditGroup;